





































































import {Component, Prop} from 'vue-property-decorator';
import {Mixins} from 'vue-mixin-decorator';
import {BaseComponent} from '@/mixins/BaseComponent';

import {Notify} from '@/utils/Notify';

import {FrequencyPlan} from '@/model/lora/FrequencyPlan';

import {ILoraForwarderFrequencyPlanService} from '@/services/lora/forwarder/ILoraForwarderFrequencyPlan.service';

import {ILoraForwarderFrequencyPlanStore} from '@/store/lora/ILoraForwarderFrequencyPlan.store';
import LoraForwarderFrequencyPlanDetails from '@/components/Lora/Forwarder/LoraForwarderFrequencyPlanDetails.vue';

@Component({
  components: {LoraForwarderFrequencyPlanDetails},
})
export default class LoraForwarderFrequencyPlanEditor extends Mixins<BaseComponent>(BaseComponent) {

  @Prop(Object)
  private forwarderStore!: ILoraForwarderFrequencyPlanStore;

  @Prop(Object)
  private forwarderService!: ILoraForwarderFrequencyPlanService;

  private selectedFrequencyPlan: FrequencyPlan | null = null;

  private showDetails: boolean = false;

  private async mounted() {
    this.setLoading();

    try {
      await this.forwarderStore.fetchFrequencyPlans();
    } catch (error) {
      Notify.Error(this.logger, 'could not get frequency plans', error);
    }

    try {
      await this.forwarderStore.fetchFrequencyPlan();
      this.selectedFrequencyPlan = this.forwarderStore.FrequencyPlan;
    } catch (error) {
      Notify.Error(this.logger, 'could not get active frequency plan', error);
    }

    this.setLoaded();
  }

  private async save() {

    if (this.selectedFrequencyPlan === null) {
      Notify.Error(this.logger, 'no frequency plan selected');
      return;
    }

    if (this.selectedFrequencyPlan.Id === this.forwarderStore.FrequencyPlan?.Id) {
      return;
    }

    try {
      await this.forwarderService.setFrequencyPlan(this.selectedFrequencyPlan.Id);
      Notify.Success(this.logger, 'Frequency plan updated, please restart the forwarder');
      const fp = this.forwarderStore?.FrequencyPlans?.find((fp: FrequencyPlan) => fp.Id === this.selectedFrequencyPlan?.Id);
      if (fp) {
        this.forwarderStore.setFrequencyPlan(fp);
      } else {
        await this.forwarderStore.fetchFrequencyPlan();
      }
    } catch (error) {
      Notify.Error(this.logger, 'could not change active frequency plan', error);
    }
  }

}
